export default __webpack_public_path__ + "static/media/vinted-logo.10b0caad.png";